import React from 'react'

export default function Topbar() {
  return (
    <div className="container-fluid bg-primary py-3">
    <div className="container">
      <div className="row">
        <div className="col-md-6 text-center text-lg-left mb-2 mb-lg-0"></div>
        <div className="col-md-6 text-center text-lg-right">
          <div className="d-inline-flex align-items-center">

          </div>
        </div>
      </div>
    </div>
  </div>
    
  )
}
